//PACKS
import React, { useState, useEffect } from "react";
import emailjs from "emailjs-com";
import LeafletMap from "./LeafletMap";
import { useSpring, animated } from "react-spring";

//STYLES
import "../styles/contact.scss";

//ASSETS
import { validEmail, validName, validMessage } from "../helpers/regex";

export default function Contact({ handleContactModal, ...props }) {
  //STATES
  const [sent, setSent] = useState(false);
  const [buttonText, setButtonText] = useState("Invia");
  const [error, setError] = useState({
    status: false,
    response: "no message",
  });

  //ON ERROR CHANGE
  useEffect(() => {
    if (error.response !== "no message") {
      setButtonText(error.response === "OK" ? "Inviato" : "Riprova");
    }
  }, [error]);

  //ON SENDMAIL ACTION
  useEffect(() => {
    if (sent) {
      handleContactModal(error);
      console.log(error);
      setSent(false);
    }
  }, [sent, error, handleContactModal]);

  //VALIDATION WITH REGEX
  function validate(target) {
    if (!validEmail.test(target.email.value)) {
      setError({ response: "Please check your email address", status: true });
      return false;
    }
    if (!validName.test(target.name.value)) {
      setError({ response: "Please check your name spelling", status: true });
      return false;
    }
    if (!validMessage.test(target.message.value)) {
      setError({ response: "Please check your message", status: true });
      return false;
    }
    return true;
  }

  function clearFields(target) {
    target.email.value = "";
    target.name.value = "";
    target.message.value = "";
  }

  //SEND MAIL
  function sendEmail(e) {
    e.preventDefault();

    if (validate(e.target)) {
      setButtonText("Sending...");
      emailjs
        .sendForm(
          "service_02cs78c",
          "template_kqy4lqi",
          e.target,
          "user_eWfBfIiht2Qeg8scvIUju"
        )
        .then(
          (result) => {
            setError({ response: result.text, status: false });
            clearFields(e.target);
          },
          (error) => {
            setError({ response: error.text, status: true });
          }
        );
    }
    setSent(true);
  }

  //ANIMATIONS
  const sendButtonAnimation = useSpring({
    backgroundColor: error.response === "OK" ? "#2a2a2a" : "#a1cec8",
    border:
      error.response === "OK" ? "solid 2px #3737378f" : "solid 2px #59968eb0",
    color: error.response === "OK" ? "#e6e6e6e6" : "#262626",
  });

  return (
    <div className="contactContainer">
      <div style={{ position: "absolute", top: "-4em" }} id="contact" />
      <div className="contactTitleContainer">
        <h2>Contatto</h2>
        <div className="separator" />
      </div>
      <div className="contactContent">
        <form onSubmit={sendEmail} className="contactForm">
          <input type="email" placeholder="Mail" name="email" />
          <input type="text" placeholder="Nome" name="name" />
          <textarea
            style={{ paddingBottom: "300px" }}
            placeholder="Messaggio"
            name="message"
          />
          <animated.button style={sendButtonAnimation} type="submit">
            {buttonText}
          </animated.button>
        </form>
        <div className="contactMap">
          {/* <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d217.44966435479517!2d10.391189867784274!3d43.716826458688914!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12d59174dbb370e9%3A0x2ddb9ea1c2570375!2sLargo%20Padre%20Renzo%20Spadoni%2C%201%2C%2056125%20Pisa%20PI%2C%20Italy!5e0!3m2!1sen!2sro!4v1627988628441!5m2!1sen!2sro"
            // width="600"
            // height="450"
            style={{
              width: "100%",
              height: "100%",
              border: "none",
            }}
            // style="border:0;"
            allowfullscreen=""
            loading="lazy"
          ></iframe> */}
          <LeafletMap />
        </div>
      </div>
    </div>
  );
}
